// 22.01.19 - These components are used to ensure that the Redux form Field and Material-UI components works correctly together.
import * as React from "react";
import { change } from "redux-form";
import TextField from "@material-ui/core/TextField";
import {
    Grid,
    FormControlLabel,
    FormControl,
    Checkbox,
    Tooltip,
    InputLabel,
    Icon,
    InputAdornment,
    Select,
} from "@material-ui/core";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { IRootState } from "src/reducers";
import { lookupTooltip } from "src/constants/tooltips";
import { UserRoles, ICountry, IssueType, CaseType, issueTypeLabels, CaseFormType } from "src/constants/api";
import Info from "@material-ui/icons/Info";
import ClearIcon from '@material-ui/icons/Clear';
// TODO: Clean this entire file up, adding types to everything

import { FieldError, FieldTextAreaError } from "../../styles/general";
// import Input from '@material-ui/core/Input';
import moment from "moment";
import {
    MAX_LENGTH_20,
    MAX_LENGTH_50,
    MAX_LENGTH_200,
    MAX_LENGTH_100,
} from "src/constants/data.js";
import { inCaseOfShipmentData } from "src/constants/dropdown";
import { useSelector } from "react-redux";

const TooltipAdornment: React.SFC<{ name: string }> = (props) => {
    const { name } = props;
    const tt: string | undefined = lookupTooltip(name);
    const endAdornment = tt && (
        <InputAdornment position="end">
            <Tooltip title={tt}>
                <Info fontSize="small" color="primary" />
            </Tooltip>
        </InputAdornment>
    );
    return endAdornment || null;
};

const ClearAdornment: React.SFC<{ props: any }> = (props) => {
    const { input, meta, disabled } = props.props;
    const { dispatch } = meta;
    const endAdornment = (
        <InputAdornment disablePointerEvents={disabled} position="end">
            <ClearIcon style={{ cursor: "pointer" }} fontSize="small" color="primary" onClick={() => {
                dispatch(change(meta.form, input.name, null));
            }} />
        </InputAdornment>
    );
    return endAdornment || null;
};

const renderFlexTextField: (props: any) => any = (props) => {
    const {
        name,
        input,
        label,
        iscurrency,
        selected,
        meta: { touched, error },
        ...custom
    } = props;

    const inputProps = iscurrency
        ? {
            startAdornment: (
                <InputAdornment position="start">
                    <span
                        style={{
                            fontSize: " ",
                            paddingBottom: "1px",
                            color: "#333",
                        }}
                    >
                        {selected}
                    </span>
                </InputAdornment>
            ),
            endAdornment: <TooltipAdornment name={input.name} />,
            maxLength: 10,
        }
        : {
            endAdornment: <TooltipAdornment name={input.name} />,
            maxLength: 10,
        };
    return (
        <React.Fragment>
            <TextField
                label={label}
                error={touched && error !== undefined}
                InputLabelProps={{ style: { paddingLeft: "5px" } }}
                InputProps={inputProps}
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
                // onInput={(e:any) => {
                //   e.target.value = Math.max(0, parseInt(e.target.value))
                //     .toString()
                //     .slice(0, 10);
                // }}
                {...input}
                {...custom}
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </React.Fragment>
    );
};

const renderFlexCurrencyField: (props: any) => any = (props) => {
    const {
        name,
        input,
        label,
        iscurrency,
        selected,
        meta: { touched, error },
        ...custom
    } = props;

    const inputProps = iscurrency
        ? {
            // pattern: "^\$\d{1,3}(,\d{3})*(\.\d+)?$",
            startAdornment: (
                <InputAdornment position="start">
                    <span
                        style={{
                            fontSize: " ",
                            paddingBottom: "1px",
                            color: "#333",
                        }}
                    >
                        {selected}
                    </span>
                </InputAdornment>
            ),
            endAdornment: <TooltipAdornment name={input.name} />,
        }
        : {
            endAdornment: <TooltipAdornment name={input.name} />,
        };
    return (
        <>
            <TextField
                label={label}
                error={touched && error !== undefined}
                InputLabelProps={{ style: { paddingLeft: "5px" } }}
                InputProps={inputProps}
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
                {...input}
                {...custom}
            // tslint:disable-next-line jsx-no-lambda
            // onKeyPress={(event: any) => {
            //   event.target.value = event.target.value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            //   }}
            // value={input.value}
            // tslint:disable-next-line jsx-no-lambda
            // onChange={() => input.value="ROHAN" }
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </>
    );
};

const renderFlexNumberField: (props: any) => any = (props) => {
    const {
        name,
        input,
        label,
        iscurrency,
        selected,
        meta: { touched, error },
        ...custom
    } = props;

    return (
        <React.Fragment>
            <TextField
                type="number"
                label={label}
                error={touched && error !== undefined}
                InputLabelProps={{ style: { paddingLeft: "5px" } }}
                // InputProps={inputProps}
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
                {...input}
                {...custom}
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </React.Fragment>
    );
};

const renderFlexTextFieldNumber: (props: any) => any = (props) => {
    const {
        // name,
        input,
        label,
        meta: { touched, error },
        ...custom
    } = props;
    return (
        <>
            <TextField
                label={label}
                type="number"
                error={touched && error !== undefined}
                InputLabelProps={{ style: { paddingLeft: "5px" } }}
                InputProps={{
                    endAdornment: <TooltipAdornment name={input.name} />,
                }}
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
                {...input}
                {...custom}
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </>
    );
};

const renderControlledField: (foo: any) => any = (props) => {
    const {
        input,
        label,
        meta: { touched, error },
        ...custom
    } = props;
    const hideadornment = !props.hideadornment
        ? { endAdornment: <TooltipAdornment name={input.name} /> }
        : {};
    return (
        <TextField
            label={label}
            disabled={true}
            error={touched && error !== undefined}
            InputLabelProps={{ style: { paddingLeft: "5px" }, shrink: true }}
            InputProps={hideadornment}
            style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
            {...input}
            {...custom}
            value={input.value || ""}
        />
    );
};

const renderTextArea = (props: any): any => {
    const {
        input,
        label,
        meta: { touched, error },
        ...custom
    } = props;
    return (
        <React.Fragment>
            <TextField
                label={label}
                multiline={true}
                rows={4}
                variant="outlined"
                rowsMax={4}
                required={custom.required}
                error={touched && error !== undefined}
                InputLabelProps={{ style: { left: "5px" } }}
                InputProps={{
                    endAdornment: <TooltipAdornment name={input.name} />,
                }}
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px", zIndex: 0 }}
                {...input}
                {...custom}
            />
            {touched && error !== undefined && (
                <FieldTextAreaError>{error}</FieldTextAreaError>
            )}
        </React.Fragment>
    );
};

export const TextArea = (props: any) => {
    return <Field {...props} component={renderTextArea} />;
};

export const FlexTextField = (props: any) => {
    return <Field {...props} component={renderFlexTextField} />;
};

export const FlexNumberField = (props: any) => {
    return <Field {...props} component={renderFlexNumberField} />;
};

export const FlexCurrencyInputField = (props: any) => {
    return <Field {...props} component={renderFlexCurrencyField} />;
};

export const FlexTextFieldNumber = (props: any) => {
    return (
        <Field
            {...props}
            InputProps={{ inputProps: { min: 2015, max: 2030 } }}
            component={renderFlexTextFieldNumber}
        />
    );
};

export const ControlledTextField = (props: any) => {
    return <Field {...props} component={renderControlledField} />;
};

export const FlexGridItem = (props: any) => {
    const { children, ...rest } = props;
    return (
        <Grid
            item={true}
            style={{ display: "flex", position: "relative" }}
            {...rest}
        >
            {children}
        </Grid>
    );
};

const renderSelectField = (props: any) => {
    const {
        input,
        label,
        meta: { touched, error },
        children,
        multiple,
        ...custom
    } = props;
    const handler = (event: any) => {
        return input.onChange(event.target.value);
    };
    return (
        <React.Fragment>
            <Select
                native={!multiple}
                multiple={multiple}
                value={input.value}
                error={touched && error !== undefined}
                {...input}
                // inputProps={{ endAdornment: <TooltipAdornment name={input.name} /> }}
                onChange={handler}
                children={children}
                {...custom}
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </React.Fragment>
    );
};

export const SelectField = (props: any) => {
    const { label, name, children, validate, shrink, ...rest } = props;
    return (
        <FormControl
            required={props.required}
            style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
        >
            <InputLabel style={{ paddingLeft: "5px" }} shrink={shrink}>{label}</InputLabel>
            <Field
                validate={validate}
                name={name}
                component={renderSelectField}
                {...rest}
            >
                {children}
            </Field>
        </FormControl>
    );
};

export const MultiSelectField = (props: any) => {
    return <SelectField multiple={true} {...props} />;
};

export const CheckBoxField = (props: any) => {
    const { name } = props;
    return (
        <Field
            name={name}
            // label={<TooltipLabel fieldName={name} label={label} />}
            component={renderCheckbox}
        />
    );
};

export interface IconFieldProps {
    name: string;
    children: JSX.Element;
}

export const BooleanIconField = (props: IconFieldProps) => {
    const { name, ...rest } = props;
    return <Field name={name} component={renderIconField} {...rest} />;
};

const renderIconField = (props: any) => {
    const { input, children } = props;
    const handleClick = (event: React.MouseEvent<HTMLSpanElement>): void => {
        event.stopPropagation();
        input.onChange(!input.value);
    };
    return <Icon onClick={handleClick}>{children}</Icon>;
};

const renderCheckbox = (props: any) => {
    const { input, label } = props;
    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={input.value ? true : false}
                    onChange={input.onChange}
                />
            }
            label={label}
        />
    );
};

const renderDateField = (props: any) => {
    const {
        label,
        input,
        meta: { touched, error },
        ...rest
    } = props;
    return (
        <React.Fragment>
            <TextField
                style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
                type="date"
                label={label}
                onChange={input.onChange}
                value={input.value || ""}
                error={touched && error !== undefined}
                InputLabelProps={{ shrink: true, style: { paddingLeft: "5px" } }}
                InputProps={{
                    endAdornment: <><TooltipAdornment name={input.name} /> <ClearAdornment props={props} /></>,
                }}
                {...rest}
            />
            {touched && error !== undefined && <FieldError>{error}</FieldError>}
        </React.Fragment>
    );
};

export const DateField = (props: any) => {
    return <Field {...props} component={renderDateField} />;
};

const renderDateTimeField = (props: any) => {
    const {
        label,
        input,
        meta: { touched, error },
        ...rest
    } = props;
    return (
        <TextField
            style={{ flex: 1, paddingLeft: "5px", paddingRight: "5px" }}
            type="datetime-local"
            label={label}
            onChange={input.onChange}
            value={input.value || ""}
            error={touched && error !== undefined}
            InputLabelProps={{ shrink: true, style: { paddingLeft: "5px" } }}
            InputProps={{ endAdornment: <><TooltipAdornment name={input.name} /> <ClearAdornment props={props} /></> }}
            {...rest}
        />
    );
};

export const DateTimeField = (props: any) => {
    return <Field {...props} component={renderDateTimeField} />;
};

// This is used to hide or display the individual fields based on other fields value.
const CondField = (props: any) => {
    const { children, hideChild, formName, condition, ...rest } = props;
    if (children.length > 1) {
        throw new Error(
            "ConditionalField: This component can only take a single child"
        );
    }
    if (!hideChild) {
        return React.cloneElement(children, { ...rest });
    } else {
        return null;
    }
};

function mapStateToProps(state: any, ownProps: any) {
    const { field, formName, condition } = ownProps;
    const selector = formValueSelector(formName);
    const shouldShow = condition(selector(state, field));
    return {
        hideChild: !shouldShow,
    };
}

export const ConditionalField = connect(mapStateToProps)(CondField);

export const SimpleCondField = (props: any) => {
    const { name, ...rest } = props;
    return (
        <Field name={name} {...rest} component={renderSimpleCondField}>
            {props.children}
        </Field>
    );
};

const renderSimpleCondField = (props: any) => {
    const { input, condition, children } = props;
    if (condition(input.value)) {
        return children;
    } else {
        return null;
    }
};

// Based on the user roles to disable the fields. We have to create one more like this for hide fields based user roles.
const RoleDisable = (props: any) => {
    if (!props.currentRoleId) {
        return null;
    }
    const {
        currentRoleId,
        roles,
        isnewcase,
        isDisableCheck,
        disablecheck,
        children,
        disableField,
        ...rest
    } = props;

    let isDisabled1 = true;

    if (!disableField) {
        if (!isnewcase) {
            isDisabled1 = roles.indexOf(currentRoleId) > -1;
        } else {
            if (isnewcase) {
                isDisabled1 = roles.indexOf(currentRoleId) > -1;
            }
            else if (isDisableCheck) {
                isDisabled1 = disablecheck ? false : true;
            } else {
                isDisabled1 = false;
            }
        }
    }

    // const isDisabled = roles.indexOf(currentRoleId) > -1;
    if (children.length > 1) {
        throw new Error(
            "DisableForRoles: This component can only take a single child"
        );
    }

    const newChild = React.cloneElement(children, {
        ...rest,
        disabled: isDisabled1,
    });
    return newChild;
};

export const DisableForRoles = connect(
    (state: IRootState) => ({
        currentRoleId: state.home.currentUser && state.home.currentUser.roleId,
    }),
    () => ({})
)(RoleDisable);

const RoleEnable = (props: any) => {
    if (!props.currentRoleId) {
        return null;
    }
    const { currentRoleId, roles, children } = props;
    const isEnabled = roles.includes(currentRoleId);
    if (children.length > 1) {
        throw new Error(
            "DisableForRoles: This component can only take a single child"
        );
    }
    const newChild = React.cloneElement(children, { disabled: !isEnabled });
    return newChild;
};

export const EnableForRoles = connect(
    (state: IRootState) => ({
        currentRoleId: state.home.currentUser && state.home.currentUser.roleId,
    }),
    () => ({})
)(RoleEnable);

interface IRoleHideOwnProps {
    roles: UserRoles[];
    children: React.ReactNode;
}

interface IRoleHideStateProps {
    hideChild: boolean;
}

type RoleHideProps = IRoleHideOwnProps & IRoleHideStateProps;

// const RoleHide: React.SFC<RoleHideProps> = (props) => {
//     // TODO: make sure we never pass roles onwards
//     const { children, hideChild, roles, ...rest } = props;
//     if (children === undefined) {
//         throw new Error("You must provide a child to HideForRoles");
//     } else if (!hideChild) {
//         return React.cloneElement(children as React.ReactElement<any>, {
//             ...rest,
//         });
//     }
//     return null;
// };

const RoleHide = (props: any) => {
    if (!props.currentRoleId) {
        return null;
    }

    // TODO: make sure we never pass roles onwards
    const { children, hideChild, currentRoleId, roles, ...rest } = props;
    if (children === undefined) {
        throw new Error("You must provide a child to HideForRoles");
    } else {
        let shouldHide = roles.indexOf(currentRoleId) > -1;
        if (!shouldHide) {
            return React.cloneElement(children as React.ReactElement<any>, {
                ...rest,
            });
        }
    }
    return null;
};

function roleHideMapStateToProps(
    state: IRootState,
    ownProps: IRoleHideOwnProps
) {
    const { roles } = ownProps;
    const shouldHide =
        state.home.currentUser && roles.indexOf(state.home.currentUser.roleId) > -1;
    return {
        hideChild: shouldHide,
    };
}

export const HideForRoles = connect((state: IRootState) => ({
    currentRoleId: state.home.currentUser && state.home.currentUser.roleId,
}), () => ({}))(RoleHide);
//export const HideForRoles = connect(roleHideMapStateToProps)(RoleHide);

/** Show the children under this component only if the logged in user is in the usernames prop */
export const ShowForUsernames = ({ usernames, children }: React.PropsWithChildren<{ usernames: string[] }>) => {
    const currentUser = useSelector((state: IRootState) => state.home.currentUser);
    return <>{usernames.includes(currentUser.userName) && children}</>;
}

export const required = (val: any, prev: any, props: any, name: string) => {
    if (
        val === undefined ||
        (Array.isArray(val) && val.length === 0) ||
        val === "" ||
        val === null
    ) {
        return `Value is required for this field`;
    }
    return undefined;
};

export const validYear = (val: any, prev: any, props: any, name: string) => {
    if (val) {
        const year = Number(val);
        if (year < 2015 || year > 2030) {
            return `Field ${name} is invalid`;
        }
    }

    return undefined;
};

export const validCurrency = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    if (val) {
        const isValid = testValidCurrency(val);
        if (!isValid) {
            // const fieldData = name.split(".");
            // return `Field ${fieldData[fieldData.length - 1]} is invalid`;
            return `Value entered is invalid`;
        }
    }

    return undefined;
};

export function timestampToDate(timestamp: string) {
    if (timestamp === undefined || timestamp === null) {
        return undefined;
    }
    return timestamp.split("T")[0];
}

export function dateToTimestamp(date: string) {
    if (date === undefined || date === null) {
        return undefined;
    }
    return date + "T00:00";
}

export function parseNumber(value: any, name: any) {
    return Number(value);
}

export function boolToInt(value: boolean | undefined): number | undefined {
    if (value === undefined) {
        return undefined;
    } else {
        return value ? 1 : 0;
    }
}

export function intToBool(value: string): boolean {
    return Number(value) === 0 ? false : true;
}

export const countryIdStringToCountries = (
    countries: ReadonlyMap<number | string, ICountry> | undefined
) => (countryIds: string | undefined) => {
    const countryIdList = countryIds ? countryIds.split(",").map(Number) : [];
    return countries
        ? countryIdList.map((cid) => countries.get(cid.toString()))
        : [];
};

export function countriesToCountryIdString(countries: ICountry[]): string {
    return countries.map((c) => c.id).join(",");
}

export const SHIPMENT_REQUIRED = [
    "description",
    "tampering",
    "sealIntact",
    "packingIntact",
    "containerNo",
    // "dateReceivedInCountry",
    "quantity",
    // "customsClearanceDate",
];

// const SHIPMENT_INVENTORY_REQUIRED = [
//   "nameOfThirdParty",
//   "contactPerson",
//   "sdaddress",
//   "email",
//   "telephone",
//   "brokerReference",
//   "claimDesignation"
// ];

export const MAIN_FORM_REQUIRED = [
    "contactPerson",
    "phone",
    "email",
    "descriptionOfTheIssue",
    "dateIssueNoticed",
    "issueType",
    "category",
    "countriesAffected",
];

export const MAIN_FORM_ISSUE_TYPE = ["inCaseOfShipment"];
const MAIN_FORM_INVALID_CURRENCY = ["expectedLossValue"];
const SHIPMENT_INVALID_CURRENCY = [
    "actualInsuredValues",
    "premium",
    "totalClaimsValuesSupplies",
    "claimsValueFreight",
    "uplift",
    "deductibleUnderThePolicy",
    "totalValueOfLoss",
];

const MAIN_FORM_INVALID_DATES = ["dateIssueNoticed"];
const SHIPMENT_FORM_INVALID_DATES = [
    "dateReceivedInCountry",
    "customsClearanceDate",
    "bldate",
    "transportStart",
    "transportEnd",
    "reportedOn",
];
const QMU_FORM_INVALID_DATES = [
    "validatedDate",
    "correctionIdentified",
    "correctionCompleted",
    "correctiveActionIdentified",
    "correctiveActionCompleted",
    "beingDrafted",
    "sentDoforPreapproval",
    "preapprovedByDo",
    "circulatedForComments",
    "circulatedForSignatures",
    "signed",
];
const SHIPMENT_INVENTORY_FORM_INVALID_DATES = [
    "grantExpiry",
    "settlementAgreed",
    "presentedForSettlement",
    "claimClosed",
];

export const checkFormValidation = (
    formValues: any,
    successCB: any,
    errorCB: any
) => {
    const values = formValues.shipments[0];
    const arrShipmentType = [1, 2, 3, 4];
    if (!values && arrShipmentType.indexOf(formValues.inCaseOfShipment) >= 0) {
        errorCB(false);
    } else {
        if (
            arrShipmentType.indexOf(formValues.inCaseOfShipment) < 0 ||
            (values.description &&
                values.tampering &&
                values.sealIntact &&
                values.packingIntact &&
                values.containerNo &&
                values.quantity)
        ) {
            // Validations for invalid currency values
            const inValidCurrency = formInvalidCurrencyFields(
                SHIPMENT_INVALID_CURRENCY,
                values
            );
            if (inValidCurrency.isInvalid) {
                errorCB(inValidCurrency.invalidFields);
                return;
            }

            // Validation for invalid date fields
            const inValidDates = formInvalidDateFields(
                SHIPMENT_FORM_INVALID_DATES,
                values
            );
            if (inValidDates.isInvalid) {
                errorCB(inValidDates.invalidFields);
                return;
            }

            // Max Length validation
            if (values.containerNo && values.containerNo.length > MAX_LENGTH_200) {
                errorCB(["containerNo"]);
                return;
            }

            if (values.sealNo && values.sealNo.length > MAX_LENGTH_200) {
                errorCB(["sealNo"]);
                return;
            }

            if (values.quantity && values.quantity.length > MAX_LENGTH_100) {
                errorCB(["quantity"]);
                return;
            }

            if (
                values.forwarderReference &&
                values.forwarderReference.length > MAX_LENGTH_100
            ) {
                errorCB(["forwarderReference"]);
                return;
            }

            if (values.salesOrderNo && values.salesOrderNo.length > MAX_LENGTH_50) {
                errorCB(["salesOrderNo"]);
                return;
            }

            if (
                values.freightForwarderName &&
                values.freightForwarderName.length > MAX_LENGTH_200
            ) {
                errorCB(["freightForwarderName"]);
                return;
            }

            if (
                values.actualFreightValue &&
                values.actualFreightValue.length > MAX_LENGTH_50
            ) {
                errorCB(["actualFreightValue"]);
                return;
            }

            if (values.shipmentValue && values.shipmentValue.length > MAX_LENGTH_50) {
                errorCB(["shipmentValue"]);
                return;
            }

            if (values.blwayBillAwb && values.blwayBillAwb.length > MAX_LENGTH_200) {
                errorCB(["blwayBillAwb"]);
                return;
            }

            if (
                values.vesselIdflightNo &&
                values.vesselIdflightNo.length > MAX_LENGTH_200
            ) {
                errorCB(["vesselIdflightNo"]);
                return;
            }

            if (
                values.meansOfTransport &&
                values.meansOfTransport.length > MAX_LENGTH_200
            ) {
                errorCB(["meansOfTransport"]);
                return;
            }

            if (
                values.transportDepartureCountry &&
                values.transportDepartureCountry.length > MAX_LENGTH_200
            ) {
                errorCB(["transportDepartureCountry"]);
                return;
            }

            if (
                values.portAirportOfDeparture &&
                values.portAirportOfDeparture.length > MAX_LENGTH_200
            ) {
                errorCB(["portAirportOfDeparture"]);
                return;
            }

            if (
                values.transportDestinationCountry &&
                values.transportDestinationCountry.length > MAX_LENGTH_200
            ) {
                errorCB(["transportDestinationCountry"]);
                return;
            }

            if (
                values.portAirportOfDestination &&
                values.portAirportOfDestination.length > MAX_LENGTH_200
            ) {
                errorCB(["portAirportOfDestination"]);
                return;
            }

            if (
                values.originIncoterm &&
                values.originIncoterm.length > MAX_LENGTH_50
            ) {
                errorCB(["originIncoterm"]);
                return;
            }

            if (
                values.destinationIncoterm &&
                values.destinationIncoterm.length > MAX_LENGTH_50
            ) {
                errorCB(["destinationIncoterm"]);
                return;
            }

            if (
                values.shipmentTotalQuantity &&
                values.shipmentTotalQuantity.length > MAX_LENGTH_50
            ) {
                errorCB(["shipmentTotalQuantity"]);
                return;
            }

            if (
                values.insurancePostingReference &&
                values.insurancePostingReference.length > MAX_LENGTH_50
            ) {
                errorCB(["insurancePostingReference"]);
                return;
            }

            if (
                values.totalNumberOfPackages &&
                values.totalNumberOfPackages.length > MAX_LENGTH_50
            ) {
                errorCB(["totalNumberOfPackages"]);
                return;
            }

            if (
                values.actualInsuredValues &&
                values.actualInsuredValues.length > MAX_LENGTH_100
            ) {
                errorCB(["actualInsuredValues"]);
                return;
            }

            if (values.premium && values.premium.length > MAX_LENGTH_100) {
                errorCB(["premium"]);
                return;
            }

            if (
                values.quantityLostPerMaterialLevel &&
                values.quantityLostPerMaterialLevel.length > MAX_LENGTH_100
            ) {
                errorCB(["quantityLostPerMaterialLevel"]);
                return;
            }

            if (
                values.totalClaimsValuesSupplies &&
                values.totalClaimsValuesSupplies.length > MAX_LENGTH_50
            ) {
                errorCB(["totalClaimsValuesSupplies"]);
                return;
            }

            if (
                values.claimsValueFreight &&
                values.claimsValueFreight.length > MAX_LENGTH_50
            ) {
                errorCB(["claimsValueFreight"]);
                return;
            }

            if (values.uplift && values.uplift.length > MAX_LENGTH_50) {
                errorCB(["uplift"]);
                return;
            }

            if (
                values.deductibleUnderThePolicy &&
                values.deductibleUnderThePolicy.length > MAX_LENGTH_50
            ) {
                errorCB(["deductibleUnderThePolicy"]);
                return;
            }

            if (
                values.totalValueOfLoss &&
                values.totalValueOfLoss.length > MAX_LENGTH_50
            ) {
                errorCB(["totalValueOfLoss"]);
                return;
            }

            if (values.recoveryValue && values.recoveryValue.length > MAX_LENGTH_50) {
                errorCB(["recoveryValue"]);
                return;
            }

            successCB(true);
        } else {
            const valKeys = Object.keys(values);
            const nonFilled = SHIPMENT_REQUIRED.filter(
                (item) => valKeys.indexOf(item) === -1
            );
            const nonFilledValues = SHIPMENT_REQUIRED.filter(
                (item) =>
                    values[item] === "" ||
                    values[item] === undefined ||
                    values[item] === null
            );
            // @ts-ignore
            const emptyFields = [...nonFilled, ...nonFilledValues];
            if (emptyFields.length) {
                errorCB(emptyFields);
                return;
            } else {
                successCB(true);
            }
        }
    }
};

export const checkValidationInventory = (
    values: any,
    successCB: any,
    errorCB: any
) => {
    if (values) {
        // Max Length Validation
        if (values.warehouseName && values.warehouseName.length > MAX_LENGTH_200) {
            errorCB(["warehouseName"]);
            return;
        }

        if (
            values.storageLocation &&
            values.storageLocation.length > MAX_LENGTH_200
        ) {
            errorCB(["storageLocation"]);
            return;
        }

        if (values.plantNo && values.plantNo.length > MAX_LENGTH_100) {
            errorCB(["plantNo"]);
            return;
        }

        if (values.address && values.address.length > MAX_LENGTH_200) {
            errorCB(["address"]);
            return;
        }

        successCB(true);
    } else {
        successCB(true);
    }
};

export const checkValidationShipInv = (
    values: any,
    successCB: any,
    errorCB: any
) => {
    if (values) {
        // Validation for invalid date fields
        const inValidDates = formInvalidDateFields(
            SHIPMENT_INVENTORY_FORM_INVALID_DATES,
            values
        );
        if (inValidDates.isInvalid) {
            errorCB(inValidDates.invalidFields);
            return;
        }

        if (values.email) {
            const isValid = testValidEmail(values.email);
            if (!isValid || values.email.length > MAX_LENGTH_50) {
                errorCB(["email"]);
                return;
            }
        }

        // Max Length Field validations
        if (values.wbsno && values.wbsno.length > MAX_LENGTH_50) {
            errorCB(["wbsno"]);
            return;
        }

        if (values.grantNo && values.grantNo.length > MAX_LENGTH_50) {
            errorCB(["grantNo"]);
            return;
        }

        if (
            values.nameOfThirdParty &&
            values.nameOfThirdParty.length > MAX_LENGTH_100
        ) {
            errorCB(["nameOfThirdParty"]);
            return;
        }

        if (
            values.amountOfRecoveryObtained &&
            values.amountOfRecoveryObtained.length > MAX_LENGTH_50
        ) {
            errorCB(["amountOfRecoveryObtained"]);
            return;
        }

        if (
            values.surveyorDetailsCompanyName &&
            values.surveyorDetailsCompanyName.length > MAX_LENGTH_100
        ) {
            errorCB(["surveyorDetailsCompanyName"]);
            return;
        }

        if (values.contactPerson && values.contactPerson.length > MAX_LENGTH_100) {
            errorCB(["contactPerson"]);
            return;
        }

        if (values.sdaddress && values.sdaddress.length > MAX_LENGTH_200) {
            errorCB(["sdaddress"]);
            return;
        }

        if (values.telephone && values.telephone.length > MAX_LENGTH_50) {
            errorCB(["telephone"]);
            return;
        }

        if (
            values.brokerReference &&
            values.brokerReference.length > MAX_LENGTH_50
        ) {
            errorCB(["brokerReference"]);
            return;
        }

        if (
            values.claimDesignation &&
            values.claimDesignation.length > MAX_LENGTH_200
        ) {
            errorCB(["claimDesignation"]);
            return;
        }
        if (
            values.sdsettlementDocumentNo &&
            values.sdsettlementDocumentNo.length > MAX_LENGTH_50
        ) {
            errorCB(["sdsettlementDocumentNo"]);
            return;
        }

        successCB(true);
    } else {
        successCB(true);
    }
};

export const validEmail = (val: any, prev: any, props: any, name: string) => {
    if (val) {
        const isValid = testValidEmail(val);
        if (!isValid) {
            // const fieldData = name.split(".");
            // return `Field ${fieldData[fieldData.length - 1]} is invalid`;
            return `Email id is invalid`;
        }
    }

    return undefined;
};

const testValidEmail = (value: any) => {
    const emailRegex: any = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const isValid = emailRegex.test(value);
    return isValid;
};

export const validPhoneNo = (val: any, prev: any, props: any, name: string) => {
    if (val) {
        const isValid = testValidPhoneNo(val);
        if (!isValid) {
            return `Phone No is invalid`;
        }
    }

    return undefined;
};

const testValidPhoneNo = (value: any) => {
    const phoneNoRegex: any = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/i;
    const isValid = phoneNoRegex.test(value);
    return isValid;
};

export const checkMainFormValidation = (
    values: any,
    requiredFields: string[],
    successCB: any,
    errorCB: any
) => {
    if (!values) {
        errorCB(false);
    } else {
        if (
            // check if all required fields are filled. If field is an array, check if it has atleast one value
            requiredFields.every((field) => {
                if (Array.isArray(values[field])) {
                    return values[field].length > 0;
                } else {
                    return values[field] !== undefined && values[field] !== "";
                }
            })
        ) {
            let isErrorOtherFields: any = false;
            let errorArr: any = [];

            // Check if Issue Type selected is Shipment
            if (values.issueType === IssueType.Shipment) {
                if (!values.inCaseOfShipment) {
                    isErrorOtherFields = true;
                    errorArr = [...errorArr, ...MAIN_FORM_ISSUE_TYPE];
                }
            }

            if (isErrorOtherFields) {
                const emptyFields = mainFormEmptyFields(errorArr, values);
                errorCB(emptyFields);
                return;
            }

            if (values.caseFormType !== CaseFormType.WarehouseNonConformity) {
                // Validations for invalid currency values
                const inValidCurrency = formInvalidCurrencyFields(
                    MAIN_FORM_INVALID_CURRENCY,
                    values
                );
                if (inValidCurrency.isInvalid) {
                    errorCB(inValidCurrency.invalidFields);
                    return;
                }
            }

            // Validation for invalid date fields
            const inValidDates = formInvalidDateFields(
                MAIN_FORM_INVALID_DATES,
                values
            );
            if (inValidDates.isInvalid) {
                errorCB(inValidDates.invalidFields);
                return;
            }

            // Check if insurance year is invalid
            if (
                (values.caseType === CaseType.Claim ||
                    values.caseType === CaseType.ComplaintClaim) &&
                values.insurancePolicyYear
            ) {
                if (
                    values.insurancePolicyYear < 2015 ||
                    values.insurancePolicyYear > 2030
                ) {
                    errorCB(["insurancePolicyYear"]);
                    return;
                }
            }

            // Check POS values
            if (values.pos && values.pos.length) {
                let posError = false;
                values.pos.forEach((posValue: any, index: any) => {
                    if (posError || posValue.deleted === true) {
                        return;
                    } else {
                        if (!posValue.poNo || !posValue.poItemNo) {
                            posError = true;
                        }
                        if (
                            (posValue.poNo && posValue.poNo.length > MAX_LENGTH_20) ||
                            (posValue.poItemNo && posValue.poItemNo.length > MAX_LENGTH_20) ||
                            (posValue.deliveryNo &&
                                posValue.deliveryNo.length > MAX_LENGTH_200) ||
                            (posValue.shipmentNo &&
                                posValue.shipmentNo.length > MAX_LENGTH_200) ||
                            (posValue.material &&
                                posValue.material.length > MAX_LENGTH_200) ||
                            (posValue.assetNumbers &&
                                posValue.assetNumbers.length > MAX_LENGTH_200)
                        ) {
                            posError = true;
                        }
                    }
                });
                if (posError) {
                    errorCB(["pos"]);
                    return;
                }
            }

            // Check Max Length for all the fields
            if (
                values.submittingOnBehalfOf &&
                values.submittingOnBehalfOf.length > MAX_LENGTH_50
            ) {
                errorCB(["submittingOnBehalfOf"]);
                return;
            }
            if (values.contactPerson && values.contactPerson.length > MAX_LENGTH_50) {
                errorCB(["contactPerson"]);
                return;
            }
            if (values.phone) {
                const isValid = testValidPhoneNo(values.phone);
                if (!isValid || values.email.length > MAX_LENGTH_50) {
                    errorCB(["phone"]);
                    return;
                }
            }

            if (values.email) {
                const isValid = testValidEmail(values.email);
                if (!isValid || values.email.length > MAX_LENGTH_50) {
                    errorCB(["email"]);
                    return;
                }
            }
            if (
                values.expectedLossValue &&
                values.expectedLossValue.length > MAX_LENGTH_50
            ) {
                errorCB(["expectedLossValue"]);
                return;
            }

            successCB(true);
        } else {
            const emptyFields = mainFormEmptyFields(requiredFields, values);
            errorCB(emptyFields);
        }
    }
};

export const checkQmuFormValidation = (
    values: any,
    successCB: any,
    errorCB: any
) => {
    if (values) {
        // Validation for invalid date fields
        const inValidDates = formInvalidDateFields(QMU_FORM_INVALID_DATES, values);
        if (inValidDates.isInvalid) {
            errorCB(inValidDates.invalidFields);
            return;
        }

        // Business Validation based on the "Validated Date" field value
        const validatedDate = values.validatedDate
            ? values.validatedDate.split("T")[0]
            : null;
        let correctionIdentifiedDate = values.correctionIdentified
            ? values.correctionIdentified.split("T")[0]
            : null;
        let correctionCompleteddDate = values.correctionCompleted
            ? values.correctionCompleted.split("T")[0]
            : null;
        let correctiveActionIdentifiedDate = values.correctiveActionIdentified
            ? values.correctiveActionIdentified.split("T")[0]
            : null;
        let correctiveActionCompletedDate = values.correctiveActionCompleted
            ? values.correctiveActionCompleted.split("T")[0]
            : null;

        if (validatedDate) {
            // Correction Identified
            if (correctionIdentifiedDate) {
                correctionIdentifiedDate = moment(
                    correctionIdentifiedDate,
                    "YYYY-MM-DD"
                );
                const momentValidatedDate = moment(validatedDate, "YYYY-MM-DD");
                let isDateBefore = correctionIdentifiedDate.isBefore(
                    momentValidatedDate
                );
                if (isDateBefore) {
                    errorCB(["correctionIdentified"]);
                    return;
                }

                // Correction completed
                if (correctionCompleteddDate) {
                    correctionCompleteddDate = moment(
                        correctionCompleteddDate,
                        "YYYY-MM-DD"
                    );
                    isDateBefore = correctionCompleteddDate.isBefore(
                        correctionIdentifiedDate
                    );
                    if (isDateBefore) {
                        errorCB(["correctionCompleted"]);
                        return;
                    }
                }
            } else {
                if (correctionCompleteddDate) {
                    errorCB(["correctionCompleted"]);
                    return;
                }
            }

            // Corrective Action Identified
            if (correctiveActionIdentifiedDate) {
                correctiveActionIdentifiedDate = moment(
                    correctiveActionIdentifiedDate,
                    "YYYY-MM-DD"
                );
                const momentValidatedDate = moment(validatedDate, "YYYY-MM-DD");
                let isDateBefore = correctiveActionIdentifiedDate.isBefore(
                    momentValidatedDate
                );
                if (isDateBefore) {
                    errorCB(["correctiveActionIdentified"]);
                    return;
                }

                // Corrective action(s) completed
                if (correctiveActionCompletedDate) {
                    correctiveActionCompletedDate = moment(
                        correctiveActionCompletedDate,
                        "YYYY-MM-DD"
                    );
                    isDateBefore = correctiveActionCompletedDate.isBefore(
                        correctiveActionIdentifiedDate
                    );
                    if (isDateBefore) {
                        errorCB(["correctiveActionCompleted"]);
                        return;
                    }
                }
            } else {
                if (correctiveActionCompletedDate) {
                    errorCB(["correctiveActionCompleted"]);
                    return;
                }
            }
        } else {
            if (correctionIdentifiedDate) {
                errorCB(["correctionIdentified"]);
                return;
            }

            if (correctiveActionIdentifiedDate) {
                errorCB(["correctiveActionIdentified"]);
                return;
            }
        }

        // Max Length field Validation
        if (
            values.centreToHandleComplaint &&
            values.centreToHandleComplaint.length > MAX_LENGTH_50
        ) {
            errorCB(["centreToHandleComplaint"]);
            return;
        }

        if (
            values.oer &&
            values.oernumber &&
            values.oernumber.length > MAX_LENGTH_50
        ) {
            errorCB(["oernumber"]);
            return;
        }

        if (
            values.oer &&
            values.financialLossToSd &&
            values.financialLossToSd.length > MAX_LENGTH_50
        ) {
            errorCB(["financialLossToSd"]);
            return;
        }

        if (
            values.validatedAsComplaint !== null &&
            values.validatedAsComplaint === 0 &&
            (values.caseComments === null || values.caseComments.trim() === "")
        ) {
            errorCB(["caseComments"]);
            return;
        }

        if (
            values.recurrent !== null &&
            values.recurrent === 1 &&
            (values.caseComments === null || values.caseComments.trim() === "")
        ) {
            errorCB(["caseComments"]);
            return;
        }

        if (values.oer === null || values.oer === "") {
            errorCB(["oer"]);
            return;
        }

        if (
            values.needForCorrection !== null &&
            values.needForCorrection === 1 &&
            (values.correction === null || values.correction.trim() === "")
        ) {
            errorCB(["correction"]);
            return;
        }

        if (
            values.needForCorrection !== null &&
            values.needForCorrection === 0 &&
            (values.caseCommentsCi === null || values.caseCommentsCi.trim() === "")
        ) {
            errorCB(["caseCommentsCi"]);
            return;
        }

        if (
            values.needforCorrectiveAction !== null &&
            values.needforCorrectiveAction === 1 &&
            (values.correctiveAction === null ||
                values.correctiveAction.trim() === "")
        ) {
            errorCB(["correctiveAction"]);
            return;
        }

        if (
            values.needforCorrectiveAction !== null &&
            values.needforCorrectiveAction === 0 &&
            (values.caseCommentsCc === null || values.caseCommentsCc.trim() === "")
        ) {
            errorCB(["caseCommentsCc"]);
            return;
        }

        successCB(true);
    } else {
        successCB(true);
    }
};

export const requiredSelect = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    if (val === undefined || val === 0 || val === "") {
        return `Value is required for this field`;
    }
    return undefined;
};

const mainFormEmptyFields = (requiredArray: any, values: any) => {
    const valKeys = Object.keys(values);
    const nonFilled = requiredArray.filter(
        (item: any) => valKeys.indexOf(item) === -1
    );
    const nonFilledValues = requiredArray.filter(
        (item: any) =>
            values[item] === "" || values[item] === undefined || values[item] === null
    );
    const emptyFields = [...nonFilled, ...nonFilledValues];
    return emptyFields;
};

const testValidCurrency = (value: any) => {
    const dollarRegex: any = /^[0-9,.]*$/g;
    const isValid = dollarRegex.test(value);
    return isValid;
};

const formInvalidCurrencyFields = (arr: any, value: any) => {
    const fields: any = [];
    arr.forEach((item: any) => {
        if (value[item] && !testValidCurrency(value[item])) {
            fields.push(item);
        }
    });
    if (fields.length) {
        return {
            isInvalid: true,
            invalidFields: fields,
        };
    } else {
        return {
            isInvalid: false,
            invalidFields: fields,
        };
    }
};

const formInvalidDateFields = (arr: any, value: any) => {
    const fields: any = [];
    arr.forEach((item: any) => {
        if (value[item] && testInvalidDate(value[item])) {
            fields.push(item);
        }
    });
    if (fields.length) {
        return {
            isInvalid: true,
            invalidFields: fields,
        };
    } else {
        return {
            isInvalid: false,
            invalidFields: fields,
        };
    }
};

const testInvalidDate = (value: any) => {
    const momentDateObj = moment(value, "YYYY-MM-DD");
    const isDateBefore = momentDateObj.isBefore("2000-01-01", "year");
    if (isDateBefore) {
        return true;
    } else {
        return false;
    }
};

/**
 * Function for converting UTC to local date format
 * @param date Date
 */
export const getLocalDateFromUTC = (date: any) => {
    if (date) {
        const localDate =
            new Date(date).getTime() - new Date().getTimezoneOffset() * 60000;
        const momentLocalData = moment(localDate).format("DD/MM/YYYY hh:mm:ss A");
        return momentLocalData;
    } else {
        return "";
    }
};

export const validDate = (val: any, prev: any, props: any, name: string) => {
    if (val) {
        const momentDateObj = moment(val, "YYYY-MM-DD");
        const isDateBefore = momentDateObj.isBefore("2000-01-01", "year");
        if (isDateBefore) {
            return "Invalid date entered";
        }

        // The below logic might be useful in future. Hence the code is kept for future reference.

        // const endDate = moment(
        //   (window as any).dateConfig.endDate,
        //   "YYYY-MM-DD"
        // ).add(360, "days");

        // const isDateAfter = momentDateObj.isAfter(endDate, "year");
        // if (isDateBefore || isDateAfter) {
        //   return "Invalid date entered";
        // }
    }
    return undefined;
};

export const handleYesNo = (val: any) => {
    if (val) {
        return "Yes";
    } else {
        return "No";
    }
};

export const handleGrantTypes = (val: any) => {
    switch (val) {
        case 1:
            return "Programme";
            break;
        case 2:
            return "Warehouse";
            break;
        case 3:
            return "PS";
            break;
        case 4:
            return "PS/GAVI";
            break;
        default:
            return "None";
    }
};

export const handleCaseType = (val: any) => {
    switch (val) {
        case 1:
            return "Complaint";
            break;
        case 2:
            return "Claim";
            break;
        case 3:
            return "Complaint & Claim";
            break;
        default:
            return "None";
    }
};

export const handleComplaintStatus = (val: any) => {
    switch (val) {
        case false:
            return "Closed";
            break;
        case true:
            return "Open";
            break;
        default:
            return "None";
    }
};

export const handleIssueType = (val: any) => {
    return issueTypeLabels[parseInt(val, 10)] ?? "None";
};

export const handleIncaseofshipment = (val: any) => {
    return inCaseOfShipmentData.find((item) => item.id === parseInt(val, 10))?.name ?? "None";
};

export const handleClaimStatus = (val: any) => {
    switch (val) {
        case 1:
            return "Open";
            break;
        case 2:
            return "Pending info";
            break;
        case 3:
            return "Submitted to broker";
            break;
        case 4:
            return "Closed";
            break;
        case 5:
            return "Withdrawn";
            break;
        default:
            return "None";
    }
};

export const handleClaimType = (val: any) => {
    switch (val) {
        case 1:
            return "Transit";
            break;
        case 2:
            return "Inventory";
            break;
        case 3:
            return "Political violence";
            break;
        default:
            return "None";
    }
};

export const handleYesNoShipment = (val: any) => {
    switch (val) {
        case false:
            return "No";
            break;
        case true:
            return "Yes";
            break;
        default:
            return "None";
    }
};

export const getPrintDate = (date: any) => {
    if (date) {
        const localDate =
            new Date(date).getTime() - new Date().getTimezoneOffset() * 60000;
        const momentLocalData = moment(localDate).format("DD/MM/YYYY");
        return momentLocalData;
    } else {
        return "";
    }
};

export const validCorrectionIdentifiedDate = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    const currentValue = val ? val.split("T")[0] : null;
    if (currentValue) {
        const { qmuForm } = props;
        const qmuValues = qmuForm.mainForm.values.qmus[0];
        const validatedDate = qmuValues.validatedDate
            ? qmuValues.validatedDate.split("T")[0]
            : null;
        if (validatedDate) {
            const correctionIdentifiedDate = moment(val, "YYYY-MM-DD");
            const momentValidatedDate = moment(qmuValues.validatedDate, "YYYY-MM-DD");
            const isDateBefore = correctionIdentifiedDate.isBefore(
                momentValidatedDate
            );
            if (isDateBefore) {
                return 'Date should be same or greater than "Validated Date"';
            }
        } else {
            return 'Please select a date for "Validated Date"';
        }
    }
    return undefined;
};

export const validCorrectiveActionIdentifiedDate = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    const currentValue = val ? val.split("T")[0] : null;
    if (currentValue) {
        const { qmuForm } = props;
        const qmuValues = qmuForm.mainForm.values.qmus[0];
        const validatedDate = qmuValues.validatedDate
            ? qmuValues.validatedDate.split("T")[0]
            : null;
        if (validatedDate) {
            const correctiveActionIdentifiedDate = moment(val, "YYYY-MM-DD");
            const momentValidatedDate = moment(qmuValues.validatedDate, "YYYY-MM-DD");
            const isDateBefore = correctiveActionIdentifiedDate.isBefore(
                momentValidatedDate
            );
            if (isDateBefore) {
                return 'Date should be same or greater than "Validated Date"';
            }
        } else {
            return 'Please select a date for "Validated Date"';
        }
    }
    return undefined;
};

export const validCorrectionCompletedDate = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    const currentValue = val ? val.split("T")[0] : null;
    if (currentValue) {
        const { qmuForm } = props;
        const qmuValues = qmuForm.mainForm.values.qmus[0];
        const correctionIdentified = qmuValues.correctionIdentified
            ? qmuValues.correctionIdentified.split("T")[0]
            : null;
        if (correctionIdentified) {
            const correctionCompletedDate = moment(val, "YYYY-MM-DD");
            const momentCorrectionIdentifiedDate = moment(
                qmuValues.correctionIdentified,
                "YYYY-MM-DD"
            );
            const isDateBefore = correctionCompletedDate.isBefore(
                momentCorrectionIdentifiedDate
            );
            if (isDateBefore) {
                return 'Date should be same or greater than "Correction(s) identified"';
            }
        } else {
            return 'Please select a date for "Correction(s) identified"';
        }
    }
    return undefined;
};

export const validCorrectiveActionCompletedDate = (
    val: any,
    prev: any,
    props: any,
    name: string
) => {
    const currentValue = val ? val.split("T")[0] : null;
    if (currentValue) {
        const { qmuForm } = props;
        const qmuValues = qmuForm.mainForm.values.qmus[0];
        const correctiveActionIdentified = qmuValues.correctiveActionIdentified
            ? qmuValues.correctiveActionIdentified.split("T")[0]
            : null;
        if (correctiveActionIdentified) {
            const correctiveActionCompletedDate = moment(val, "YYYY-MM-DD");
            const momentCorrectiveActionIdentified = moment(
                qmuValues.correctiveActionIdentified,
                "YYYY-MM-DD"
            );
            const isDateBefore = correctiveActionCompletedDate.isBefore(
                momentCorrectiveActionIdentified
            );
            if (isDateBefore) {
                return 'Date should be same or greater than "Corrective action(s) identified"';
            }
        } else {
            return 'Please select a date for "Corrective action(s) identified"';
        }
    }
    return undefined;
};

// Validations for max field length
const maxLength = (max: any) => (value: any) =>
    value && value.length > max
        ? `Value should be ${max} characters or less`
        : undefined;
export const maxLength50 = maxLength(MAX_LENGTH_50);
export const maxLength200 = maxLength(MAX_LENGTH_200);
export const maxLength20 = maxLength(MAX_LENGTH_20);
export const maxLength100 = maxLength(MAX_LENGTH_100);
